// CommentsList.js
import { useState } from 'react';
import Comment from '../comment';

const CommentsList = () => {
    const [comments, setComments] = useState([
        {
            username: 'Blue Sky',
            avatar: 'https://via.placeholder.com/32x32',
            text: 'He has a great smile He has a face only a mother could love. He has got dimples. One of his eyes is bigger than the other!',
            time: 'One Hour Ago',
        },
        {
            username: 'Blue Sky',
            avatar: 'https://via.placeholder.com/32x32',
            text: 'He has a great smile He has a face only a mother could love. He has got dimples. One of his eyes is bigger than the other!',
            time: 'One Hour Ago',
        },
        {
            username: 'Blue Sky',
            avatar: 'https://via.placeholder.com/32x32',
            text: 'He has a great smile He has a face only a mother could love. He has got dimples. One of his eyes is bigger than the other!',
            time: 'One Hour Ago',
        },
        {
            username: 'Blue Sky',
            avatar: 'https://via.placeholder.com/32x32',
            text: 'He has a great smile He has a face only a mother could love. He has got dimples. One of his eyes is bigger than the other!',
            time: 'One Hour Ago',
        },
        {
            username: 'Blue Sky',
            avatar: 'https://via.placeholder.com/32x32',
            text: 'He has a great smile He has a face only a mother could love. He has got dimples. One of his eyes is bigger than the other!',
            time: 'One Hour Ago',
        },
        {
            username: 'Blue Sky',
            avatar: 'https://via.placeholder.com/32x32',
            text: 'He has a great smile He has a face only a mother could love. He has got dimples. One of his eyes is bigger than the other!',
            time: 'One Hour Ago',
        },
    ]);

    const [newComment, setNewComment] = useState('');

    const handleAddComment = () => {
        const newCommentData = {
            username: 'New User',
            avatar: 'https://via.placeholder.com/32x32',
            text: newComment,
            time: 'Just now',
        };
        setComments([newCommentData, ...comments]);
        setNewComment('');
    };

    return (
        <div className="w-full p-4 bg-stone-50 rounded-lg flex flex-col gap-4">
            <div className="flex gap-2 items-center">
                <input
                    className="flex-grow p-3 bg-white rounded-lg text-sm placeholder-gray-400 text-gray-700"
                    type="text"
                    placeholder="Type your comment..."
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                />
                <button
                    className="p-3 bg-purple-100 rounded-full hover:bg-purple-300 transition-colors duration-200 ease-in-out"
                    onClick={handleAddComment}
                >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1124_1639)">
                            <path
                                d="M17.8294 2.27267C17.9196 2.38182 17.977 2.51426 17.995 2.65468C18.0131 2.7951 17.991 2.93776 17.9314 3.06617L12.5689 14.5827C12.5227 14.682 12.4553 14.77 12.3714 14.8404C12.2875 14.9109 12.1892 14.9621 12.0834 14.9906C11.9776 15.019 11.8669 15.0238 11.759 15.0049C11.6511 14.9859 11.5487 14.9435 11.4589 14.8807L7.33391 12.0017C7.17209 11.8873 7.06211 11.7136 7.02798 11.5184C6.99385 11.3232 7.03836 11.1224 7.15176 10.9599C7.26517 10.7975 7.43827 10.6865 7.63326 10.6512C7.82824 10.6159 8.02926 10.6592 8.19241 10.7717L11.5854 13.1402L15.9079 3.85717L2.58191 7.17967L5.33841 9.01217C5.45507 9.08963 5.59108 9.13289 5.73105 9.13704C5.87102 9.1412 6.00936 9.10608 6.13041 9.03567L10.2739 6.62617C10.4458 6.52612 10.6505 6.49846 10.8428 6.54928C11.0351 6.6001 11.1994 6.72524 11.2994 6.89717C11.3995 7.0691 11.4271 7.27373 11.3763 7.46605C11.3255 7.65836 11.2003 7.82262 11.0284 7.92267L6.88491 10.3327C6.52156 10.5441 6.10623 10.6496 5.68601 10.637C5.26579 10.6245 4.85749 10.4944 4.50741 10.2617L0.336409 7.48767C0.215244 7.40717 0.120107 7.29316 0.0625866 7.15954C0.00506595 7.02593 -0.0123555 6.87847 0.0124444 6.73513C0.0372444 6.59179 0.103195 6.45875 0.202263 6.35223C0.301331 6.2457 0.42924 6.17029 0.570409 6.13517L17.0704 2.02217C17.2077 1.98802 17.3519 1.99341 17.4863 2.03774C17.6207 2.08207 17.7398 2.16351 17.8299 2.27267H17.8289H17.8294Z"
                                fill="#4A00E0"/>
                            <path
                                d="M8.46273 12.0737C8.60779 12.2098 8.69286 12.3979 8.69923 12.5967C8.70561 12.7955 8.63277 12.9886 8.49673 13.1337L5.79823 16.0127C5.69539 16.1226 5.56188 16.199 5.41507 16.2319C5.26825 16.2649 5.11491 16.2529 4.97497 16.1976C4.83504 16.1423 4.71498 16.0461 4.63041 15.9217C4.54583 15.7972 4.50065 15.6502 4.50073 15.4997V12.6202C4.50072 12.5217 4.52011 12.4242 4.55779 12.3332C4.59547 12.2422 4.65072 12.1595 4.72036 12.0898C4.79001 12.0202 4.87269 11.9649 4.96369 11.9272C5.0547 11.8895 5.15223 11.8701 5.25073 11.8701C5.34923 11.8701 5.44677 11.8895 5.53777 11.9272C5.62877 11.9649 5.71146 12.0202 5.7811 12.0898C5.85075 12.1595 5.90599 12.2422 5.94368 12.3332C5.98136 12.4242 6.00075 12.5217 6.00073 12.6202V13.6027L7.40323 12.1077C7.5393 11.9627 7.72741 11.8776 7.92619 11.8712C8.12497 11.8649 8.31815 11.9377 8.46323 12.0737H8.46273Z"
                                fill="#4A00E0"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_1124_1639">
                                <rect width="18" height="18" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>

                </button>
            </div>
            <div style={{width: 397, height: 0, border: '1px #EFEFEF solid'}}></div>
            <div className="flex flex-col gap-2">
                {comments.map((comment, index) => (
                    <Comment key={index} {...comment} />
                ))}
            </div>
            {/* 这里可以添加一个按钮来加载更多评论 */}
        </div>
    );
};

export default CommentsList;
